import { persistedEnumAtom } from '@/core/state';
import { StorageKey } from '@/core/storage';

export const trailsVisibilityAtom = persistedEnumAtom<'on' | 'off'>(StorageKey.Trails, ['on', 'off'], 'on');
